<template>
    <DialogBase class="dialog-welcome" :persistent="true">

        <template #title>
            Free Trial
        </template>

        <template #content>
            <div class="content">
                <div class="gift">
                    <v-icon icon="fa-solid fa-gifts"></v-icon>
                </div>
                <span>Welcome to your <strong>three-day free trial</strong> of GENERIO.</span>
                <span>Jump right in and start creating your 3D models.</span>
            </div>
        </template>

        <template #actions>
            <v-btn 
                size="large"
                variant="elevated" 
                color="color1" 
                elevation="1" 
                @click="handleClose">
                <v-icon icon="fa-solid fa-rocket"></v-icon>
                <span>&nbsp;Let's Go&nbsp;</span>
            </v-btn>
        </template>

    </DialogBase>
</template>

<script>
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { DialogBase } from '@generio-ai/library-legacy/components/dialogs'

export default {
    name: 'DialogWelcome',
    components: {
        DialogBase
    },
    methods: 
    {
        ...mapActions('dialogs', [
            'close'
        ]),
        handleClose()
        {
            this.close()
        }
    }
}
</script>

<style scoped>
.dialog-welcome .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
}

.dialog-welcome .content .gift {
    min-height: 8rem;
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
        135deg,
        rgba(var(--v-theme-color1), 1) 0%,
        rgba(var(--v-theme-color2), 1) 100%
    );
    border-radius: 8px;
}

.dialog-welcome .content .gift .v-icon {
    font-size: 6rem;
    color: white;
}

.dialog-welcome .content span {
    font-size: 1.1rem;
}
</style>